import { ChevronDown } from 'lucide-react';
import React, { useState } from 'react'

interface AccordionWrapperProps {
  icon: React.ReactNode;
  title: string;
  children: React.ReactNode;
  isOpenAtStart?: boolean;
}

export default function AccordionWrapper({ icon, title, children, isOpenAtStart }: AccordionWrapperProps) {
  const [isOpen, setIsOpen] = useState<boolean>(isOpenAtStart || false);
  const toggle = () => setIsOpen((open) => !open);
  return (
    <div
      className={`
    w-full max-w-4xl border rounded-lg
    ${isOpen ? 'border-transparent' : ''}
    `}
    >
      <div
        role="button"
        tabIndex={0}
        aria-expanded={isOpen}
        className="flex justify-between items-center p-2 cursor-pointer select-none rounded-lg hover:bg-neutral-50/80"
        onClick={toggle}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggle();
          }
        }}
      >
        <div className='flex items-center gap-2'>
          {icon}
          <h3 className='hidden md:block'>{title}</h3>
          <h4 className='md:hidden'>{title}</h4>
        </div>

        <ChevronDown
          className={`text-[#225424] transform transition-transform duration-300 shrink-0 ${isOpen ? 'rotate-180' : ''}`}
        />
      </div>
      {
        isOpen && <div className='border-l p-2 ml-4 cursor-auto'>
          {children}
          </div>
      }
    </div>
  )
}